/**
 * Risorse umane (WALLIYO-0131), in italiano. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrIt = {
  "hr.tabs.aria": "Risorse umane",
  "hr.tab.directory": "Rubrica",
  "hr.tab.recruiting": "Selezione",
  "hr.tab.employees": "Dipendenti",
  "hr.tab.learning": "Formazione",
  "hr.subTabs.aria": "Dipendenti",
  "hr.sub.records": "Fascicoli",
  "hr.sub.joining": "Ingressi",
  "hr.sub.timeOff": "Ferie di tutti",
  "hr.sub.performance": "Prestazioni",
  "hr.sub.payroll": "Buste paga",
  "hr.sub.reviews": "Revisioni",
  "hr.sub.leaving": "Uscite",
  "hr.locked": "Questa scheda è per le risorse umane.",
  "hr.notBuilt": "Non ancora costruito.",
  "hr.notBuiltHelp": "Questa scheda è progettata e attende il suo endpoint. Non si perde nulla.",
  "directory.title": "Rubrica",
  "directory.sub": "Chiunque può cercare chiunque.",
  "directory.search": "Trovare qualcuno",
  "directory.searchHelp": "Un nome, o il numero del badge.",
  "directory.searchPlaceholder": "Nome o UUID",
  "directory.go": "Cerca",
  "directory.clear": "Mostra tutti",
  "directory.loading": "Lettura della rubrica…",
  "directory.failed": "Non è stato possibile leggere la rubrica.",
  "directory.retry": "Riprova",
  "directory.none": "Nessuno qui corrisponde a «{query}».",
  "directory.empty": "Non c'è ancora nessuno in elenco.",
  "directory.count": "{shown} di {total}",
  "directory.more": "Più risultati di quelli mostrati. Restringi la ricerca.",
  "directory.colName": "Nome",
  "directory.colRoles": "Ruolo",
  "directory.colTeams": "Team",
  "directory.colManager": "Responsabile",
  "directory.open": "Apri",
  "directory.noRole": "Ancora nessun ruolo",
  "directory.noTeam": "Ancora nessun team",
  "directory.noManager": "Nessun responsabile",
  "directory.leads": "lo guida",
  "directory.invited": "Invitato",
  "directory.back": "Torna alla rubrica",
  "directory.identity": "Chi è",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "Il numero del badge. Non cambia mai.",
  "directory.email": "E-mail",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Tutti nei loro team",
  "directory.whereTheySit": "Dove si colloca",
  "directory.emailThem": "Invia un'e-mail",
  "directory.teammatesNone": "È l'unica persona nei suoi team.",
  "directory.personFailed": "Non è stato possibile leggere questa persona.",
  "directory.viewOnly": "La rubrica mostra solo la struttura. Cosa può fare qualcuno è in Dipendenti.",
  "hr.loading": "Lettura…",
  "hr.failed": "Non è stato possibile leggere.",
  "hr.retry": "Riprova",
  "joining.invite": "Invitare qualcuno",
  "joining.invited.title": "Inviti in sospeso",
  "joining.invited.help": "Hanno già un UUID e non possono accedere finché non impostano una password.",
  "joining.invited.none": "Nessuno sta aspettando di arrivare.",
  "joining.arrived.title": "Arrivati di recente",
  "joining.arrived.help": "Tutti quelli entrati negli ultimi 30 giorni.",
  "joining.arrived.none": "Nessuno è entrato negli ultimi 30 giorni.",
  "joining.col.name": "Nome",
  "joining.col.roles": "Ruolo",
  "joining.col.sent": "Invitato il",
  "joining.col.waiting": "In attesa da",
  "joining.col.joined": "Entrato il",
  "joining.today": "Oggi",
  "joining.waiting": "{days} giorni",
  "joining.stale": "Vale un sollecito",

  // ── Leaving ──
  "leaving.who": "Chi se ne va",
  "leaving.whoHelp": "Tutti quelli ancora qui, e quelli già andati via.",
  "leaving.pick": "Scegliere qualcuno",
  "leaving.alreadyLeft": "già andato",
  "leaving.nobody": "Scegli qualcuno per vedere cosa lascerebbe la sua uscita.",
  "leaving.gone": "{name} è già andato via. Ecco cosa è rimasto in sospeso.",
  "leaving.noReason": "Nessun motivo indicato",
  "leaving.teams.title": "Team che guida",
  "leaving.teams.help":
    "In un team senza guida nessuno approva le ferie, nessuno rivede nessuno e nessuno attesta gli accessi: è lo stesso fatto.",
  "leaving.teams.none": "Non guida nessun team.",
  "leaving.teams.col.team": "Team",
  "leaving.teams.col.others": "Altre persone",
  "leaving.teams.col.after": "Dopo l'uscita",
  "leaving.team.others": "{count} altri",
  "leaving.team.noLead": "Nessuno lo guiderebbe",
  "leaving.team.covered": "Lo guida qualcun altro",
  "leaving.team.handOver": "Passare ad altri",
  "leaving.grants.title": "Concesso a suo nome",
  "leaving.grants.help":
    "Togliere un ruolo non tocca mai questo. Una concessione senza scadenza è il modo in cui chi è andato via conserva un permesso.",
  "leaving.grants.none": "Non gli è stato concesso nulla a suo nome.",
  "leaving.grants.col.what": "Cosa",
  "leaving.grants.col.why": "Perché",
  "leaving.grants.col.ends": "Termina",
  "leaving.grant.forever": "Non termina mai",
  "leaving.grant.until": "Fino al",
  "leaving.grants.revoke": "Revocare questi",
  "leaving.last.title": "L'ultimo passo",
  "leaving.last.help":
    "Disattivare chiude le sue {sessions} sessioni aperte e gli impedisce di accedere. Nulla di ciò che ha fatto viene rimosso — il registro lo nomina per sempre — e resta elencato nei suoi team, così nessuno si ritrova silenziosamente con una persona in meno.",
  "leaving.last.deactivate": "Disattivare",
  "leaving.last.seeThem": "Vederlo nella rubrica",

  // ── Records ──
  "records.find": "Cerca",
  "records.findPlaceholder": "Nome o e-mail",
  "records.team": "Team",
  "records.role": "Ruolo",
  "records.any": "Tutti",
  "records.dueReview": "{count} accessi da rivedere",
  "records.accessDueReview": "accesso da rivedere",
  "records.none": "Nessuno corrisponde.",
  "records.neverSeen": "Mai entrato",
  "records.col.person": "Persona",
  "records.col.role": "Ruolo",
  "records.col.teams": "Team",
  "records.col.joined": "Entrato il",
  "records.col.lastSeen": "Visto l'ultima volta",

  // ── Time off ──
  "timeOff.ask": "Chiedere ferie",
  "timeOff.approve": "Approvare",
  "timeOff.refuse": "Rifiutare",
  "timeOff.days": "{days} giorni",
  "timeOff.decidedBy": "Deciso da {name}",
  "timeOff.col.who": "Chi",
  "timeOff.col.kind": "Tipo",
  "timeOff.col.when": "Quando",
  "timeOff.col.days": "Giorni",
  "timeOff.col.status": "Stato",
  "timeOff.kind.annual": "Ferie annuali",
  "timeOff.kind.sick": "Malattia",
  "timeOff.kind.unpaid": "Non retribuito",
  "timeOff.kind.parental": "Congedo parentale",
  "timeOff.kind.other": "Altro",
  "timeOff.status.pending": "In attesa",
  "timeOff.status.approved": "Approvato",
  "timeOff.status.refused": "Rifiutato",
  "timeOff.status.withdrawn": "Ritirato",
  "timeOff.balance.title": "Il tuo saldo",
  "timeOff.balance.none":
    "Nessuno ha ancora fissato il tuo diritto. Le risorse umane lo fanno sul tuo fascicolo di impiego.",
  "timeOff.balance.allowance": "Diritto",
  "timeOff.balance.taken": "Godute",
  "timeOff.balance.pending": "Richieste",
  "timeOff.balance.pendingHelp": "Non godute, ma nemmeno libere.",
  "timeOff.balance.left": "Restanti",
  "timeOff.toDecide.title": "In attesa di te",
  "timeOff.toDecide.help": "Guidi il loro team, quindi decidi tu. Essere nelle risorse umane non è la stessa cosa.",
  "timeOff.mine.title": "Le tue richieste",
  "timeOff.mine.none": "Non hai chiesto ferie.",
  "timeOff.away.title": "Assenti oggi",
  "timeOff.away.none": "Oggi non manca nessuno.",
  "timeOff.everybody.title": "Di tutti",
  "timeOff.everybody.help": "Lo vedi perché sei nelle risorse umane. A decidere è chi guida il loro team.",
  "timeOff.form.title": "Chiedere ferie",
  "timeOff.form.kind": "Tipo",
  "timeOff.form.from": "Primo giorno",
  "timeOff.form.to": "Ultimo giorno",
  "timeOff.form.days": "Giorni",
  "timeOff.form.daysHelp": "Quanti giorni lavorativi copre.",
  "timeOff.form.reason": "Motivo",
  "timeOff.form.submit": "Inviare la richiesta",
  "timeOff.decide.title": "Decidere questa richiesta",
  "timeOff.decide.approveNote": "Di' perché approvi",
  "timeOff.decide.refuseNote": "Di' perché rifiuti",
  "timeOff.decide.submit": "Registrare la decisione",
  "timeOff.done": "{days} giorni richiesti. Decide chi guida il tuo team.",
  "timeOff.approvedDone": "Le ferie di {name} sono approvate.",
  "timeOff.refusedDone": "La richiesta di {name} è rifiutata.",

  // ── Reviews ──
  "reviews.grants.title": "Da guardare adesso",
  "reviews.grants.help":
    "Una concessione con scadenza si ritira da sola. Queste sono quelle che non lo fanno, e quelle di chi non c'è più.",
  "reviews.grants.none": "Non c'è nulla concesso a nome proprio senza scadenza.",
  "reviews.leads.title": "Responsabili che devono rivedere le loro persone",
  "reviews.leads.help": "Chi guida il loro team lo sappiamo già: nessuno deve sentirsi dire chi rivede chi.",
  "reviews.leads.none": "Nessuno nei team ha qualcosa concesso a suo nome.",
  "reviews.col.who": "Chi",
  "reviews.col.what": "Cosa",
  "reviews.col.why": "Perché",
  "reviews.col.concern": "Problema",
  "reviews.col.lead": "Responsabile",
  "reviews.col.team": "Team",
  "reviews.col.people": "Persone",
  "reviews.col.neverEnding": "Senza fine",
  "reviews.concern.holderLeft": "Se n'è andato",
  "reviews.concern.neverEnds": "Non termina mai",
  "reviews.concern.neverUsed": "Mai usato",
  "reviews.changedAt": "Modificato il {when}",
  "reviews.open": "Aprire i suoi permessi",

  // ── Payroll ──
  "payroll.month": "Mese",
  "payroll.open": "Aprire un mese",
  "payroll.close": "Chiudere il mese",
  "payroll.notOpen": "Questo mese non è ancora stato aperto.",
  "payroll.closedOn": "Chiuso il {when} da {name}",
  "payroll.hold": "Sospendere",
  "payroll.release": "Sbloccare",
  "payroll.lines.title": "Quanto prende ciascuno",
  "payroll.lines.help":
    "Tratto dai fascicoli di impiego com'erano all'apertura del mese. Un aumento successivo non cambia quanto è qui.",
  "payroll.col.person": "Persona",
  "payroll.col.gross": "Lordo",
  "payroll.col.contributions": "Contributi",
  "payroll.col.net": "Netto",
  "payroll.col.status": "Stato",
  "payroll.status.ready": "Pronta",
  "payroll.status.held": "Sospesa",
  "payroll.status.paid": "Pagata",
  "payroll.total.people": "Persone",
  "payroll.total.gross": "Lordo",
  "payroll.total.contributions": "Contributi",
  "payroll.total.net": "Netto",
  "payroll.missing.title": "Di queste persone nessuno sa quanto guadagnano",
  "payroll.missing.help":
    "Il loro fascicolo non indica un lordo, quindi una busta paga non può pagarle. Va inserito prima del mese prossimo.",
  "payroll.openForm.title": "Aprire un mese",
  "payroll.openForm.month": "Mese",
  "payroll.openForm.help":
    "Ogni fascicolo con un lordo riceve una riga. I contributi partono da zero: quanto si trattiene dipende da dove si trova la persona, e non tocca a questa schermata indovinarlo.",
  "payroll.openForm.submit": "Aprire",
  "payroll.holdForm.title": "Modificare questa riga",
  "payroll.holdForm.hold": "Sospenderla",
  "payroll.holdForm.release": "Sbloccarla",
  "payroll.closeForm.title": "Chiudere il mese",
  "payroll.closeForm.help":
    "Ogni riga pronta diventa pagata. Una sospesa resta sospesa, che è il motivo per cui è stata sospesa.",
  "payroll.closeForm.submit": "Chiudere",
  "payroll.opened": "{month} è aperto, con {count} righe.",
  "payroll.held": "La riga di {name} è sospesa.",
  "payroll.released": "La riga di {name} sarà pagata.",
  "payroll.closed": "Il mese è chiuso.",

  // ── Performance ──
  "performance.cycle": "Ciclo",
  "performance.openCycle": "Aprire un ciclo",
  "performance.noCycle": "Non è ancora stato aperto alcun ciclo.",
  "performance.runs": "Dal {from} al {to}",
  "performance.write": "Scrivere",
  "performance.keepWriting": "Continuare",
  "performance.col.who": "Chi",
  "performance.col.reviewer": "Valutatore",
  "performance.col.status": "Stato",
  "performance.col.outcome": "Com'è andata",
  "performance.status.notStarted": "Non iniziata",
  "performance.status.inProgress": "In scrittura",
  "performance.status.submitted": "Inviata",
  "performance.status.signedOff": "Approvata",
  "performance.gap.noTeam": "In nessun team",
  "performance.gap.noLead": "Il team non ha una guida",
  "performance.gap.leadsOwn": "Guida il proprio team",
  "performance.toWrite.title": "In attesa di te",
  "performance.toWrite.help": "Guidi il loro team, quindi la scrivi tu.",
  "performance.mine.title": "La tua valutazione",
  "performance.mine.none": "Non hai una valutazione in questo ciclo.",
  "performance.everybody.title": "Di tutti",
  "performance.everybody.help": "Lo vedi perché sei nelle risorse umane. A scriverla è il valutatore.",
  "performance.everybody.gaps":
    "{count} di queste non hanno nessuno che le scriva. Riguarda l'organizzazione, non questo ciclo.",
  "performance.form.title": "Aprire un ciclo",
  "performance.form.name": "Nome",
  "performance.form.opens": "Primo giorno",
  "performance.form.closes": "Ultimo giorno",
  "performance.form.submit": "Aprire",
  "performance.writeForm.title": "Scrivere la valutazione",
  "performance.writeForm.outcome": "Com'è andata",
  "performance.writeForm.outcomeHelp": "Una parola che scegli tu, non un voto su cinque.",
  "performance.writeForm.note": "Cosa è successo",
  "performance.writeForm.save": "Salvare per dopo",
  "performance.writeForm.send": "Inviare",
  "performance.opened": "{name} è aperto, con {count} valutazioni.",
  "performance.saved": "Salvata. Nessuno la vede finché non la invii.",
  "performance.sent": "Inviata. {name} ora può vederla.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Aprire una posizione",
  "recruiting.editJob": "Modificare",
  "recruiting.addCandidate": "Aggiungere qualcuno",
  "recruiting.move": "Far avanzare",
  "recruiting.none": "Non è ancora stata aperta alcuna posizione.",
  "recruiting.noTeam": "Nessun team",
  "recruiting.noCandidates": "Non si è ancora candidato nessuno.",
  "recruiting.liveCandidates": "{count} in gioco",
  "recruiting.col.candidate": "Candidato",
  "recruiting.col.reach": "Come raggiungerlo",
  "recruiting.col.stage": "Fase",
  "recruiting.col.applied": "Candidatura",
  "recruiting.stage.applied": "Candidatura",
  "recruiting.stage.screening": "Preselezione",
  "recruiting.stage.interview": "Colloquio",
  "recruiting.stage.offer": "Offerta inviata",
  "recruiting.stage.hired": "Assunto",
  "recruiting.stage.declined": "Respinto",
  "recruiting.stage.withdrawn": "Ritirato",
  "recruiting.status.open": "Aperta",
  "recruiting.status.onHold": "In pausa",
  "recruiting.status.filled": "Coperta",
  "recruiting.status.closed": "Chiusa",
  "recruiting.jobForm.title": "Aprire una posizione",
  "recruiting.jobForm.name": "Titolo",
  "recruiting.jobForm.team": "Team",
  "recruiting.jobForm.noTeam": "Ancora nessun team",
  "recruiting.jobForm.description": "Di cosa si tratta",
  "recruiting.jobForm.status": "Stato",
  "recruiting.jobForm.submit": "Aprire",
  "recruiting.candidateForm.title": "Aggiungere qualcuno",
  "recruiting.candidateForm.name": "Nome",
  "recruiting.candidateForm.phone": "Telefono",
  "recruiting.candidateForm.email": "E-mail",
  "recruiting.candidateForm.note": "Cosa vale la pena sapere",
  "recruiting.candidateForm.submit": "Aggiungere",
  "recruiting.moveForm.title": "Far avanzare",
  "recruiting.moveForm.stage": "Fase",
  "recruiting.moveForm.hired":
    "Segnare qualcuno come assunto registra che lo è stato. Invitarlo si fa in Ingressi, dove già esiste.",
  "recruiting.moveForm.submit": "Far avanzare",
  "recruiting.jobOpened": "{title} è aperta.",
  "recruiting.jobEdited": "{title} è aggiornata.",
  "recruiting.candidateAdded": "{name} è in elenco.",
  "recruiting.candidateMoved": "{name} ora è a {stage}.",
  "learning.addCourse": "Aggiungere un corso",
  "learning.enrol": "Iscriversi",
  "learning.continue": "Continuare",
  "learning.finish": "Concludere",
  "learning.alreadyEnrolled": "Iscritto",
  "learning.requiredBy": "Richiesto da {permission}: da concludere prima della concessione, non dopo.",
  "learning.requiredOfAll": "Obbligatorio per tutti",
  "learning.anybody": "Aperto a tutti",
  "learning.minutes": "{minutes} min",
  "learning.enrolled": "{count} iscritti",
  "learning.hrOnly": "Solo risorse umane",
  "learning.mine.title": "Obbligatorio per te",
  "learning.mine.help": "Un corso legato a un permesso va concluso prima che il permesso sia concesso.",
  "learning.mine.none": "Al momento non c'è nulla di obbligatorio per te.",
  "learning.catalogue.title": "Catalogo",
  "learning.catalogue.help":
    "Aperto a tutti. Iscriversi non richiede il permesso di nessuno: lo richiede la concessione dietro il corso.",
  "learning.byTeam.title": "In tutta l'azienda",
  "learning.byTeam.help": "Chi deve ancora i corsi obbligatori. A sollecitare è chi guida il team.",
  "learning.col.course": "Corso",
  "learning.col.status": "Stato",
  "learning.col.progress": "Avanzamento",
  "learning.col.team": "Team",
  "learning.col.people": "Persone",
  "learning.col.done": "Fatto",
  "learning.status.enrolled": "Iscritto",
  "learning.status.inProgress": "In corso",
  "learning.status.done": "Concluso",
  "learning.courseForm.title": "Aggiungere un corso",
  "learning.courseForm.name": "Titolo",
  "learning.courseForm.audience": "Per chi",
  "learning.courseForm.minutes": "Quanto dura, in minuti",
  "learning.courseForm.required": "Richiesto da un permesso",
  "learning.courseForm.requiredHelp": "L'id dell'impostazione del permesso di cui questo corso è condizione.",
  "learning.courseForm.everybody": "Obbligatorio per tutti",
  "learning.courseForm.submit": "Aggiungere",
  "learning.courseAdded": "{title} è nel catalogo.",
  "learning.enrolledDone": "Iscritto a {title}.",
  "learning.finished": "{title} è concluso.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Chiudi",
  "error.reason.permission_not_held":
    "Il tuo ruolo apre questa schermata, ma non questa azione. Chiedilo a chi può concederla.",
  "error.reason.not_found": "Questo non esiste più. Ricarica e riprova.",
  "error.reason.no_reason": "Di' perché, in poche parole.",
  "error.reason.name_taken": "Quel nome è già preso.",
  "error.reason.team_closed": "Questo è chiuso. Riaprilo prima di aggiungere qualcuno.",
  "error.reason.staff_deactivated": "Questa persona se n'è andata e non può essere aggiunta.",
  "error.reason.lead_must_be_member": "Si guida solo un team di cui si fa parte.",
  "error.reason.duplicate_change": "La stessa persona compare due volte. Inviala una sola volta.",
  "error.reason.own_request": "Non puoi decidere le tue ferie.",
  "error.reason.not_their_lead":
    "Solo chi guida il loro team può deciderlo. Essere nelle risorse umane non è la stessa cosa.",
  "error.reason.already_decided": "È già stato deciso. Ricarica per vedere come.",
  "error.reason.backwards": "L'ultimo giorno viene prima del primo.",
  "error.reason.too_long": "È più lungo di quanto una richiesta possa coprire.",
  "error.reason.month_open": "Quel mese è già aperto.",
  "error.reason.already_paid": "Questa riga è stata pagata. Un mese chiuso è ciò che è stato pagato.",
  "error.reason.already_closed": "Questo mese è già chiuso.",
  "error.reason.nobody_payable": "Nessun fascicolo di impiego riporta un lordo.",
  "error.reason.invalid_month": "Indica il mese come AAAA-MM.",
  "error.reason.own_review": "Non puoi scrivere la tua valutazione.",
  "error.reason.not_the_reviewer": "È stato chiesto a qualcun altro di scriverla.",
  "error.reason.signed_off": "Questa valutazione è stata approvata.",
  "error.reason.no_outcome": "Di' com'è andata prima di inviarla.",
  "error.reason.job_closed": "Questa posizione è chiusa. Riaprila prima di aggiungere qualcuno.",
  "error.reason.candidate_out": "Questa persona non è più in gioco. Aggiungila di nuovo se torna.",
  "error.reason.title_taken": "Quel titolo è già preso.",
  "error.reason.course_retired": "Questo corso non viene più tenuto.",
  "error.reason.invalid_progress": "L'avanzamento è una percentuale intera, da 0 a 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Tutto",
  "roles.covers.features": "{count} funzionalità",
  "roles.covers.permissions": "{count} permessi",
  "roles.covers.critical": "{count} critiche",
  "roles.covers.high": "{count} alte",
  "roles.covers.seeAll": "Vedere tutte e {count}",
  "roles.covers.permissionsHeading": "Permessi",

  // ── Roles, redesigned ──
  "roles.band.critical": "ruoli possono decidere cosa può fare chiunque",
  "roles.band.people": "persone ne hanno uno",
  "roles.band.total": "ruoli in tutto",
  "roles.band.unheld": "non li ha nessuno",
  "roles.reach.critical": "Critico",
  "roles.reach.high": "Alto",
  "roles.reach.low": "Basso",
  "roles.rail.people": "{count} persone",
  "roles.rail.unheld": "non lo ha nessuno",
  "roles.noDescription": "Senza descrizione",
  "roles.figure.people": "Persone",
  "roles.figure.features": "Funzionalità",
  "roles.figure.permissions": "Permessi",
  "roles.figure.critical": "Critiche",
  "roles.block.holders": "Chi lo ha",
  "roles.block.holdersHelp": "Dare questo ruolo a qualcuno gli dà tutto quanto segue.",
  "roles.block.holdersNone": "Nessuno ha questo ruolo.",
  "roles.block.give": "Darlo a qualcuno",
  "roles.block.take": "Toglierlo",
  "roles.block.grants": "Cosa concede",
  "roles.block.grantsHelp": "Fin dove arriva, per area.",
  "roles.block.criticalWarning": "Chi ha questo ruolo può decidere cosa possono fare tutti gli altri.",
  "roles.block.change": "Cambiare cosa concede",
  "roles.block.opens": "Cosa apre",
  "roles.block.opensHelp": "Calcolato dalle funzionalità qui sopra, mai salvato: il menu chiede alla stessa funzione.",
  "roles.block.opensNone": "Da solo non apre nessuna schermata.",
  "roles.block.compare": "Confrontato con",
  "roles.block.compareWith": "Confrontare con",
  "roles.compare.only": "{count} solo qui",
  "roles.compare.theirs": "{count} solo lì",
  "roles.compare.shared": "{count} in comune",
  "roles.give.title": "Dare questo ruolo a qualcuno",
  "roles.give.who": "A chi",
  "roles.give.submit": "Darlo",
  "roles.give.done": "{name} ora ha {role}.",
  "roles.take.title": "Togliere questo ruolo",
  "roles.take.body": "Mantiene tutti gli altri ruoli.",
  "roles.take.submit": "Toglierlo",
  "roles.take.done": "{name} non ha più {role}.",
  "roles.holdersUnknown": "Non leggibile",
  "roles.compare.same": "Concedono esattamente le stesse funzionalità.",
  "roles.notice.critical": "{roles} di questi possono decidere cosa può fare chiunque — {people} persone ne hanno uno.",
  "roles.notice.criticalOnly": "{roles} di questi possono decidere cosa può fare chiunque.",
  "roles.notice.unheld": "{count} non li ha nessuno.",

  // ── Actions, by person ──
  "actions.find": "Trovare qualcuno",
  "actions.matches": "Chi intendevi?",
  "actions.findPlaceholder": "Nome o UUID",
  "actions.nobody": "Cerca qualcuno per vedere cosa può fare.",
  "actions.noRoles": "Nessun ruolo",
  "actions.col.on": "Attiva",
  "actions.col.source": "Origine",
  "actions.col.reason": "Motivo",
  "actions.mustAsk": "deve chiedere oltre {limit}",
  "actions.clear": "Cancellare",
  "actions.until": "fino al {when}",
  "actions.onlyOverrides":
    "Solo un'eccezione è impostata su questa persona, quindi è l'unica che questa schermata può togliere. Tutto il resto viene da un ruolo o da come l'azione è rilasciata: modificali dove vivono.",
  "actions.blocked.permission": "Ha la funzionalità, non il permesso che questa azione richiede.",
  "actions.locked.noFeature": "Aperta a tutti: dietro non c'è alcun interruttore.",
  "actions.view.catalogue": "Il catalogo",
  "actions.view.person": "Per persona",
  "actions.notWiredYet": "L'attivazione non è ancora collegata. Usa Funzionalità e Permessi per ora.",
  "actions.view.role": "Per ruolo",
  "actions.pickRole": "Ruolo",

  // ── Switching an action ──
  "actions.switch.onTitle": "Attivare",
  "actions.switch.offTitle": "Disattivare",
  "actions.switch.clearTitle": "Cancellare",
  "actions.switch.submit": "Attivare",
  "actions.switch.writes": "Questo scrive la funzionalità che sta dietro: {feature}.",
  "actions.switch.alsoMoves":
    "Quella funzionalità apre anche {count} altre azioni, che si muovono con essa: {actions}.",
  "actions.switch.permissionToo": "Mancherà ancora il permesso che protegge questa azione. Concedilo in Permessi.",
  "actions.switch.switchedOn": "{action} è attiva per {who}.",
  "actions.switch.switchedOff": "{action} è disattiva per {who}.",
  "actions.switch.cleared": "{action} torna a ciò che eredita.",
  "actions.pending": "non ancora salvato",
  "actions.saved": "{count} interruttori salvati.",
} as const;
